import { map, tap } from 'rxjs/operators';
import { exhaustMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { toastEvents } from '@navstation-portal/shared/data-access/toaster';
import { FileDownloaderService } from '@navstation-portal/shared/util/browser';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature } from '@ngrx/signals';
import { Events, injectDispatch, withEventHandlers } from '@ngrx/signals/events';
import { EngineReportsService } from '../engine-reports-service/engine-reports.service';
import { engineReportsEvents } from './engine-reports-events';
import { mapEngineReportsResponse } from './engine-reports.mapper';
import { buildExtractFilename } from './extract-filename';

export function withEngineReportsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      const events = inject(Events);
      const engineReportsService = inject(EngineReportsService);
      const fileDownloader = inject(FileDownloaderService);
      const toastDispatcher = injectDispatch(toastEvents);

      return {
        fetchEngineReports$: events.on(engineReportsEvents.fetchEngineReports).pipe(
          exhaustMap(({ payload: vesselId }) =>
            engineReportsService.getEngineReports(vesselId).pipe(
              map(mapEngineReportsResponse),
              mapResponse({
                next: (reports) => engineReportsEvents.fetchedEngineReports(reports),
                error: console.error,
              })
            )
          )
        ),
        extractEngineReports$: events.on(engineReportsEvents.extractEngineReports).pipe(
          exhaustMap(({ payload: { vesselId, vesselName, reportFilter } }) =>
            engineReportsService.extractEngineReports(vesselId, reportFilter).pipe(
              tap((blob) => fileDownloader.download(blob, buildExtractFilename(vesselName, reportFilter))),
              mapResponse({
                next: () => engineReportsEvents.extractEngineReportsSuccess(),
                error: () => engineReportsEvents.extractEngineReportsFailed(),
              })
            )
          )
        ),
        extractEngineReportsSuccess$: events.on(engineReportsEvents.extractEngineReportsSuccess).pipe(
          tap(() => {
            toastDispatcher.toastSuccess({
              summary: 'Success',
              detail: 'Report extract successful!',
            });
          })
        ),
        extractEngineReportsFailed$: events.on(engineReportsEvents.extractEngineReportsFailed).pipe(
          tap(() => {
            toastDispatcher.toastError({
              summary: 'Error',
              detail: 'Error extracting data, try again in a bit!',
            });
          })
        ),
      };
    })
  );
}
